module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/why-cannot-i-use-vux-with-cdn-51.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/faq/why-cannot-i-use-vux-with-cdn.md
// module id = 753
// module chunks = 184